export const ISO_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSSSS";
export const MINUTE_DATE_FORMAT = "YYYY-MM-DD HH:mm";